import React, { Component } from 'react';
import { styled } from '@mui/material/styles';
import Axios from 'axios';

import { API_URL } from '../../utils/config/config';

import Header from '../../components/post-security/common/header';
import Sidebar from '../../components/post-security/common/sidebar';
import Settings from '../../components/post-security/settings_view/settings.js';
import Footer from '../../components/post-security/common/footer';

import {Typography, Button, Paper, Snackbar} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { Replay } from '@mui/icons-material';

const PREFIX = 'SettingsContainer';

const classes = {
    root_grid: `${PREFIX}-root_grid`,
    main: `${PREFIX}-main`,
    pm_view: `${PREFIX}-pm_view`,
    header: `${PREFIX}-header`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.root_grid}`]: {
        display: 'grid',
        height: '100vh',
        gridTemplateRows: '4em auto 2em',
        overflowY: 'visible',
    },

    [`& .${classes.main}`]: {
        paddingLeft: '70px',
        paddingTop: '20px',
        paddingRight: '70px',
    },

    [`& .${classes.pm_view}`]: {
        maxWidth: 'calc(100vw - 70px - 60px - 30px)',
        overflowX: 'auto',
    },

    [`& .${classes.header}`]: {
        zIndex: 999999,
    }
}));

class SettingsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: false,
            offline: false,
            pmResourceNames: [],
            filters: {},
            snackbar_show: false,
            snackbar_message: '',
            snackbar_type: 'info'
        };
        this.fetchFilterData = this.fetchFilterData.bind(this);
        this.updateFilters = this.updateFilters.bind(this);
    }

    fetchFilterData = async () => {
        if (localStorage.getItem('id')) {
            try {
                const { getAccessTokenSilently } = this.props.auth;
                const token = await getAccessTokenSilently();
    
                const responseFetchPMResourceNames = await Axios.get(`${API_URL}pm_resources_names/`,            
                {
                    withCredentials: true,
                    headers: {
                        'content-type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });
                responseFetchPMResourceNames.data.sort((a, b) => (a.name > b.name) ? 1 : -1)
                
                const responseFetchFilterData = await Axios.get(`${API_URL}pm_view_filters/${localStorage.getItem('id')}/`,
                {
                    withCredentials: true,
                    headers: {
                        'content-type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        this.setState({
                            filters: response.data.filters,
                            pmResourceNames: responseFetchPMResourceNames.data,
                            loading: false,
                        });
                    }
                }
                );
            }
            catch (error) {
                this.setState({ error: error });
            }    
        }
    }

    updateFilters = async (filter_type, filter_value) => {
        // Show saving snackbar
        this.setState({
            snackbar_show: true,
            snackbar_message: 'Saving...',
            snackbar_type: 'info'
        });

        const obj = {};
        obj[filter_type] = filter_value;
        const new_filters = Object.assign({}, this.state.filters, obj);
        this.setState({ filters: new_filters });

        const { getAccessTokenSilently } = this.props.auth;
        const token = await getAccessTokenSilently();

        const data = {
            "user_id": localStorage.getItem('id'),
            "filters": new_filters
        };

        Axios.patch(
            `${API_URL}pm_view_filters/${localStorage.getItem('id')}/`,
            data,
            {
                withCredentials: true,
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }            
        ).then((response) => {
            if (response.status === 200) {
                // Show success snackbar
                this.setState({
                    snackbar_show: true,
                    snackbar_message: 'Change Saved Successfully',
                    snackbar_type: 'success'
                });
            }
        }).catch(error => {
            console.log(error);
            // Show error snackbar
            this.setState({
                snackbar_show: true,
                snackbar_message: 'Error Saving Change',
                snackbar_type: 'error'
            });
        });      
    }


    componentDidMount() {
        document.title = "Roster Settings";
        this.fetchFilterData();
    }

    render() {
        return (
            <Root>
                <div className={classes.root_grid}>
                    <div className={classes.header}>
                        {/* ***** Header Area ***** */}
                        <Header />
                    </div>
                    <div>
                        {this.state.offline ? (
                            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                You are offline!
                            </div>
                        ) : this.state.error ? (
                            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                <Typography variant="h5" style={{ fontFamily: 'inherit' }} gutterBottom>
                                    <strong>An error occured!</strong>
                                </Typography>
                                <center>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        onClick={() => window.location.reload()}
                                    >
                                        <Replay /> Try again
                                    </Button>
                                </center>
                            </div>
                        ) : (      
                            <>
                            <Sidebar />  
                            <div  className={classes.main}>
                                {/* ***** Main Banner Area ***** */}
                                <Paper className={classes.pm_view}>
                                    <Settings 
                                        loading={this.state.loading} 
                                        filters={this.state.filters}
                                        pmResourceNames={this.state.pmResourceNames}
                                        updateFilters={this.updateFilters}
                                    />
                                </Paper>
                            </div>
                            <Snackbar 
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                open={this.state.snackbar_show}
                                autoHideDuration={2000}
                                onClose={() => this.setState({snackbar_show: false})}
                            >
                                <MuiAlert elevation={6} variant="filled" severity={this.state.snackbar_type}>
                                    {this.state.snackbar_message}
                                </MuiAlert>
                            </Snackbar>                            

                            </>
                            )}
                        </div>
                    <div>
                        {/* ***** Footer ***** */}
                        <Footer />
                    </div>                
                </div>
            </Root>
        );
    }
}

export default SettingsContainer;
